export default __webpack_public_path__ + "static/media/tmall.a31a8f5b.png";